import { render, staticRenderFns } from "./Classification.vue?vue&type=template&id=2f7141d4&scoped=true&"
import script from "./Classification.vue?vue&type=script&lang=js&"
export * from "./Classification.vue?vue&type=script&lang=js&"
import style0 from "./Classification.vue?vue&type=style&index=0&id=2f7141d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7141d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7141d4')) {
      api.createRecord('2f7141d4', component.options)
    } else {
      api.reload('2f7141d4', component.options)
    }
    module.hot.accept("./Classification.vue?vue&type=template&id=2f7141d4&scoped=true&", function () {
      api.rerender('2f7141d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Classification.vue"
export default component.exports